import { jsx as _jsx } from "react/jsx-runtime";
import { is2StepsPlanAhead } from '~/utils/helpers';
import TwoStepsPreNeedPopup from './twoStepsPreNeedPopup';
import ThreeStepsPreNeedPopup from './threeStepsPreNeedPopup';
import { connect } from 'react-redux';
import { getCustomConfig } from '~/selectors/event';
const TWO_STEPS_PLAN_AHEAD = is2StepsPlanAhead();
const PreNeedPopup = (props) => TWO_STEPS_PLAN_AHEAD ? _jsx(TwoStepsPreNeedPopup, { ...props }) : _jsx(ThreeStepsPreNeedPopup, { ...props });
const mapStateToProps = (state) => ({
    logo: state.event.data.venue.logo_full,
    website: state.event.data.venue.website,
    eventStatus: state.event.data.status,
    customConfig: getCustomConfig(state),
});
export default connect(mapStateToProps)(PreNeedPopup);
